import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/affirmationProgramEntitlement/importer/affirmationProgramEntitlementImporterActions';

export default importerReducers(actions);
